import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, GridColDef, ruRU } from '@mui/x-data-grid';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddIcon from '@mui/icons-material/Add';
import {
  Box,
  createTheme,
  IconButton,
  Stack,
  Tab,
  Tabs,
  ThemeProvider,
} from '@mui/material';
import {
  getDefaultAlertProps,
  getIdFromArray,
  getModule,
  getNameArray,
  getNameFromArray,
  getSelectedLng,
  getViewType,
  unixToLocal,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  LANGUAGE_RUS,
  MAIN_COLOR_STRING,
  PAGE_SIZE_DEVICES,
  PC_VIEW,
  START_PAGE_SIZE_DEVICES,
} from '../../constant/constants';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyTextFiled } from '../UI/MyTextField';
import { UserDto } from '../../dto/user/UserDto';
import { ModuleDto } from '../../dto/user/ModuleDto';
import { apiGetUser } from '../../service/user/apiGetUser';
import { apiGetModule } from '../../service/user/apiGetModule';
import { apiDeleteUser } from '../../service/user/apiDeleteUser';
import { apiAddUser } from '../../service/user/apiAddUser';
import { apiDeleteModule } from '../../service/user/apiDeleteModule';
import { apiAddModule } from '../../service/user/apiAddModule';
import { MyAutoComplete } from '../UI/MuAutoComplete';

export const UserDiv = () => {
  const [pageSize, setPageSize] = React.useState(START_PAGE_SIZE_DEVICES);
  const { t } = useTranslation();
  const moduleTypes = getModule();
  const [backDrop, setBackDrop] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [userDto, setUserDto] = useState<UserDto>({
    id: -1,
    datetime: '',
    name: '',
    organization: '',
    status: 0,
    userId: '',
  });

  const [moduelDto, setModuleDto] = useState<ModuleDto>({
    id: '',
    datetime: '',
    name: '',
    organization: '',
    status: 0,
    userId: '',
    datetimeTo: '',
    module: -1,
  });
  const [userDtos, setUserDtos] = useState<UserDto[]>([]);
  const [moduleDtos, setModuleDtos] = useState<ModuleDto[]>([]);

  const getUser = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetUser();
    if (apiResult.isSuccess) {
      setUserDtos(apiResult.data.userId);
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const getModules = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetModule();
    if (apiResult.isSuccess) {
      setModuleDtos(apiResult.data.modules);
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const deleteUser = async (dto: UserDto) => {
    const apiResult: IApiResult = await apiDeleteUser(dto);
    if (apiResult.isSuccess) {
      getUser();
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const addUser = async (dto: UserDto) => {
    const apiResult: IApiResult = await apiAddUser(dto);
    if (apiResult.isSuccess) {
      getUser();
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const deleteModule = async (dto: ModuleDto) => {
    const apiResult: IApiResult = await apiDeleteModule(dto);
    if (apiResult.isSuccess) {
      getModules();
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const addModule = async (dto: ModuleDto) => {
    const apiResult: IApiResult = await apiAddModule(dto);
    if (apiResult.isSuccess) {
      getModules();
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const [checkHelper, setCheckHelper] = useState(false);

  const handelCreate = async () => {
    if (userDto?.userId === '' || userDto?.organization === '') {
      setCheckHelper(true);
      return;
    }
    await addUser(userDto);
  };

  const handelCreateNeww = async () => {
    if (moduelDto?.userId === '' || moduelDto?.datetimeTo === '') {
      setCheckHelper(true);
      return;
    }
    await addModule(moduelDto);
  };

  const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    getSelectedLng() === LANGUAGE_RUS ? ruRU : {}
  );

  const [value, setValue] = React.useState('one');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (value === 'one') {
      getUser();
    } else {
      getModules();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const columnsAppId: GridColDef[] = [
    {
      field: 'organization',
      headerName: 'Организация',
      renderHeader: () => <strong>Организация</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.organization,
    },
    {
      field: 'name',
      headerName: 'Пользователь',
      renderHeader: () => <strong>Пользователь</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.name,
    },
    {
      field: 'userId',
      headerName: 'Рабочая станция',
      renderHeader: () => <strong>Рабочая станция</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.userId,
    },
    {
      field: 'datetime',
      headerName: 'Дата активации',
      renderHeader: () => <strong>Дата активации</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.datetime,
    },
    {
      field: 'id',
      type: 'actions',
      width: 70,
      headerName: '',
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (row) => (
        <Stack direction="row" width="100%" justifyContent="center">
          <IconButton
            size="small"
            title={t('tooltipDelete')}
            onClick={() => deleteUser(row.row)}
          >
            <DeleteForeverIcon
              fontSize="small"
              sx={{
                color: 'red',
              }}
            />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const columnsToken: GridColDef[] = [
    {
      field: 'userId',
      headerName: 'Рабочая станция',
      renderHeader: () => <strong>Рабочая станция</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.userId,
    },
    {
      field: 'organization',
      headerName: 'Организация',
      renderHeader: () => <strong>Организация</strong>,
      flex: 1,
      minWidth: 250,
      editable: false,
      renderCell: (row) => row.row.organization,
    },
    {
      field: 'datetime',
      headerName: 'Дата активации',
      renderHeader: () => <strong>Дата активации</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.datetime,
    },
    {
      field: 'datetimeTo',
      headerName: 'Дата действия',
      renderHeader: () => <strong>Дата действия</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.datetimeTo,
    },
    {
      field: 'module',
      headerName: 'Модуль',
      renderHeader: () => <strong>Модуль</strong>,
      minWidth: 250,
      editable: false,
      renderCell: (row) => getNameFromArray(moduleTypes, row.row.module),
    },
    {
      field: 'id',
      type: 'actions',
      width: 35,
      headerName: '',
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (row) => (
        <Stack direction="row" width="100%" justifyContent="center">
          <IconButton
            size="small"
            title={t('tooltipDelete')}
            onClick={() => deleteModule(row.row)}
          >
            <DeleteForeverIcon
              fontSize="small"
              sx={{
                color: 'red',
              }}
            />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const other = {
    autoHeight: true,
    showCellRightBorder: true,
    showColumnRightBorder: true,
  };

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" alignItems="center" marginBottom="20px" spacing={2}>
        <Stack width="90%" spacing={1}>
          <Tabs value={value} onChange={handleChange}>
            <Tab value="one" label="Рабочая станция" />
            <Tab value="two" label="Модули" />
          </Tabs>
          {value === 'one' && (
            <Stack direction="row" spacing={1}>
              <MyTextFiled
                value={userDto.organization}
                autoComplete="off"
                onChange={(e) =>
                  setUserDto({ ...userDto, organization: e.target.value })
                }
                size="small"
                error={checkHelper}
                label="Организация"
              />
              <MyTextFiled
                value={userDto.name}
                autoComplete="off"
                onChange={(e) =>
                  setUserDto({ ...userDto, name: e.target.value })
                }
                size="small"
                error={checkHelper}
                label="Пользователь"
              />
              <MyTextFiled
                value={userDto.userId}
                onChange={(e) =>
                  setUserDto({
                    ...userDto,
                    userId: e.target.value,
                  })
                }
                autoComplete="off"
                size="small"
                error={checkHelper}
                label="Рабочая станция"
              />
              <Stack alignItems="center">
                <IconButton
                  sx={{ color: MAIN_COLOR_STRING }}
                  onClick={handelCreate}
                >
                  <AddIcon />
                </IconButton>
              </Stack>
            </Stack>
          )}
          {value === 'two' && (
            <Stack direction="row" spacing={1}>
              <MyTextFiled
                value={moduelDto.userId}
                autoComplete="off"
                onChange={(e) =>
                  setModuleDto({ ...moduelDto, userId: e.target.value })
                }
                size="small"
                error={checkHelper}
                label="Рабочая станция"
              />
              <MyAutoComplete
                value={
                  moduelDto.module !== undefined && moduelDto.module !== -1
                    ? getNameFromArray(moduleTypes, moduelDto.module)
                    : ''
                }
                onChange={(e, v) =>
                  setModuleDto({
                    ...moduelDto,
                    module: getIdFromArray(moduleTypes, v),
                  })
                }
                error={checkHelper}
                arrayList={getNameArray(moduleTypes)}
                size="small"
                maxHeightDropList="500px"
                label="Модуль"
              />
              <MyTextFiled
                value={moduelDto.datetimeTo}
                autoComplete="off"
                onChange={(e) =>
                  setModuleDto({ ...moduelDto, datetimeTo: e.target.value })
                }
                size="small"
                error={checkHelper}
                label="Дата действия (в формате ГГГГ-ММ-ДД)"
              />
              <Stack alignItems="center">
                <IconButton
                  sx={{ color: MAIN_COLOR_STRING }}
                  onClick={handelCreateNeww}
                >
                  <AddIcon />
                </IconButton>
              </Stack>
            </Stack>
          )}
          <Box
            sx={{
              '& .app-theme-cell': {
                fontFamily: 'sans-serif',
              },
            }}
          >
            <ThemeProvider theme={theme}>
              <DataGrid
                sx={{
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                    py: 1,
                    fontSize: '100px',
                  },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                    py: '5px',
                  },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                    py: '10px',
                  },
                  '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within':
                    {
                      outline: 'none !important',
                    },
                }}
                getRowHeight={() => 'auto'}
                columns={value === 'one' ? columnsAppId : columnsToken}
                rows={value === 'one' ? userDtos : moduleDtos}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...other}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={PAGE_SIZE_DEVICES}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
              />
            </ThemeProvider>
          </Box>
        </Stack>
      </Stack>
    </div>
  );
};
